import React from 'react';
import cx from 'classnames';
import {
    Button,
    ChooseDropdown,
    DropdownSelectTrigger,
    Flex,
    HTMLDialog,
    noop,
    Text,
    CheckBox
} from '@priority-software/priority-style-react';
import {DialogToolbarContent} from '../../../../../../components/Dialog/DialogToolbar/DialogToolbar';
import texts from '../../../../texts';
import styles from './styles.module.scss';

type Props = {
    onClose: () => void;
};

export const CopyHomepageDialog = (props: Props) => {
    const {onClose} = props;

    return (
        <HTMLDialog
            isOpen
            width={720}
            onClose={onClose}
            toolbarContent={
                <DialogToolbarContent
                    mainTitle={texts.copy_homepage_dialog_title}
                    subTitle={texts.copy_homepage_dialog_sub_title}
                />
            }
            content={
                <div className={styles.content}>
                    <Text skin="paragraph-2">
                        Run this program to copy Home page from user to another user.
                    </Text>

                    <div className={styles.formGrid}>
                        <div className={styles.formRow}>
                            <div className={styles.labelColumn}>
                                <Text skin="paragraph-2">{texts.copy_from_user_label}</Text>
                            </div>

                            <div className={styles.controlColumn}>
                                <div style={{width: 60}}>
                                    <DropdownSelectTrigger />
                                </div>

                                <div style={{flexGrow: 1}}>
                                    <DropdownSelectTrigger />
                                </div>
                            </div>
                        </div>

                        <div className={styles.formRow}>
                            <div className={styles.labelColumn}>
                                <Text skin="paragraph-2">{texts.copy_to_user_label}</Text>
                            </div>

                            <div className={styles.controlColumn}>
                                <div style={{width: 60}}>
                                    <DropdownSelectTrigger />
                                </div>

                                <div style={{flexGrow: 1}}>
                                    <DropdownSelectTrigger />
                                </div>
                            </div>
                        </div>

                        <div className={cx(styles.formRow, styles.padding)}>
                            <div className={styles.controlColumn}>
                                <CheckBox checked={false} value={''} onChange={noop} name="">
                                    {texts.copy_insights_label}
                                </CheckBox>
                            </div>
                        </div>

                        <div className={cx(styles.formRow, styles.padding)}>
                            <div className={styles.controlColumn}>
                                <CheckBox checked={false} value={''} onChange={noop} name="">
                                    {texts.copy_shortcuts_label}
                                </CheckBox>
                            </div>
                        </div>

                        <div className={cx(styles.formRow, styles.padding)}>
                            <div className={styles.controlColumn}>
                                <CheckBox checked={false} value={''} onChange={noop} name="">
                                    {texts.copy_groups_label}
                                </CheckBox>
                            </div>
                        </div>

                        <div className={styles.formRow}>
                            <div className={styles.labelColumn}>
                                <Text skin="paragraph-2">{texts.copy_from_language_label}</Text>
                            </div>

                            <div className={styles.controlColumn}>
                                <div style={{width: 60}}>
                                    <DropdownSelectTrigger />
                                </div>

                                <div style={{flexGrow: 1}}>
                                    <DropdownSelectTrigger />
                                </div>
                            </div>
                        </div>

                        <div className={styles.formRow}>
                            <div className={styles.labelColumn}>
                                <Text skin="paragraph-2">{texts.copy_to_language_label}</Text>
                            </div>

                            <div className={styles.controlColumn}>
                                <div style={{width: 60}}>
                                    <ChooseDropdown
                                        trigger={<DropdownSelectTrigger />}
                                        value="="
                                        onChange={noop}
                                        data={[{label: '=', value: '='}]}
                                    />
                                </div>

                                <div style={{flexGrow: 1}}>
                                    <DropdownSelectTrigger />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            footer={
                <Flex>
                    <Button skin="text">{texts.copy_dialog_clear_btn}</Button>
                    <Flex justifyContent="flex-end" style={{gap: 16}}>
                        <Button wideButton size="large" skin="secondary" onClick={onClose}>
                            {texts.btn_cancel}
                        </Button>
                        <Button wideButton size="large" skin="primary">
                            {texts.copy_dialog_copy_btn}
                        </Button>
                    </Flex>
                </Flex>
            }
        />
    );
};
